import * as theme from "./FormFooterWrapper.css";

export function FormFooterWrapper({ children }: { children: React.ReactNode }) {
    return <div className={theme.root}>{children}</div>;
}
